import React from 'react'

function CardHeader ({ children, className = '', withPadding, withMargin = true }) {
  const classNames = [
    'flex',
    'items-center',
    'justify-between',
    withMargin ? 'mb-4 sm:mb-8' : '',
    withPadding ? 'px-6 sm:px-10' : '',
    className
  ]

  return (
    <div className={classNames.join(' ')}>
      {children}
    </div>
  )
}

export default CardHeader
